import { Injectable, Signal } from '@angular/core';
import { IDebitsData, IDebitsModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { DebitsActions, DebitsSelectors, IDebitsState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class DebitsStore extends StateAccessService<IDebitsState> {
  readonly state$: Observable<IDebitsState>;

  readonly data$$: Signal<IDebitsData>;
  readonly model$$: Signal<IDebitsModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(DebitsSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(DebitsSelectors.data);
  }

  dispatchDebitsReset() {
    this.stateFacade.dispatch(DebitsActions.reset());
  }
  dispatchUpdateModel({ model }: { model: IDebitsModel }) {
    this.stateFacade.dispatch(DebitsActions.updateModel({ model }));
  }
  dispatchDebitsLoad() {
    this.stateFacade.dispatch(DebitsActions.load());
  }
  dispatchDebitsLoadSuccess({ model, data }: { model: IDebitsModel; data: IDebitsData }) {
    this.stateFacade.dispatch(DebitsActions.loadSuccess({ model, data }));
  }
  dispatchDebitsSubmit() {
    this.stateFacade.dispatch(DebitsActions.submit());
  }
  dispatchDebitsSubmitSuccess({ model, data }: { model: IDebitsModel; data: IDebitsData }) {
    this.stateFacade.dispatch(DebitsActions.submitSuccess({ model, data }));
  }
  dispatchDebitsLoadFailure(error: any) {
    this.stateFacade.dispatch(DebitsActions.loadFailure({ error }));
  }
}
